import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { useLocation } from 'react-router-dom';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const ConsentStartStep: React.FC = () => {
  const { goNext, updateSelfServiceData } = useWizard();
  const loc = useLocation();
  const [title, setTitle] = useState<string>('Samtykke');
  const [intro, setIntro] = useState<string>('Denne proces hjælper dig med at afgive samtykke digitalt.');

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas_samtykke.consent_start).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setIntro(c.body[0]);}
    });
  }, []);
  return (
    <StepContainer title={title}>
      <InfoBox type="info"><p>{intro}</p></InfoBox>
      <NavigationButtons onNext={goNext} showBack={false} nextText="Start samtykke" />
    </StepContainer>
  );
};

export default ConsentStartStep;
